import React from 'react';

import { H3, H4 } from '../../primitives/appTitle';
import AppSection from '../../primitives/appSection';
import PatternSvg from '../../components/svg/patternSvg';
import { FrontCommonMessages } from '../../appCommonTranslations';
import { ShText } from '@shoootin/translations';
import { SliderScanOfferWrapper } from './sliderOfferWrapper';
import CoverMatterport from '../../components/coverMatterport';
import { ProfessionShootingType } from '../../appConstants';
import { MetierPageOffersScan } from './metierPageOffers';
import { getProfessionMessage } from '../../appMessageDefinitions';

const MetierScanSection = ({
  profession,
  scanId,
  offers,
}: {
  profession: ProfessionShootingType;
  scanId: string;
  offers?: MetierPageOffersScan;
}) => {
  return (
    <AppSection className="metier-section matterport left darker">
      <div className="metier-content">
        <div className="metier-gallery">
          <CoverMatterport
            path={scanId}
            // nav={MatterportNav}
          />
          <span className="metier-pattern" data-parallax="0.1">
            <PatternSvg />
          </span>
        </div>
        <div className="metier-text">
          <H3>
            <ShText message={FrontCommonMessages.professionScanSectionTitle} />
          </H3>
          <p>
            <ShText
              message={getProfessionMessage(profession, 'scanDescription')}
            />
          </p>
          {/*<AppLink>*/}
          {/*<AppText message={FrontCommonMessages.seeGallery} />*/}
          {/*</AppLink>*/}
        </div>
      </div>
      {offers && offers.scanOffers.length > 0 && (
        <>
          <div className="metier-slider">
            <H4>
              <ShText
                message={getProfessionMessage(profession, 'scanOffers')}
              />
              {/*<span className="metier-pattern" data-parallax="-0.1">*/}
              {/*<PatternSvg />*/}
              {/*</span>*/}
            </H4>
            <SliderScanOfferWrapper
              offer={offers.scanOffers[0]}
              currency={offers.currency}
              shootingType={profession}
            />
          </div>

          {/*<div className="metier-options">
            <H4>Options supplémentaires</H4>

            <Options options={{} as any} />
            </div>*/}
        </>
      )}
    </AppSection>
  );
};

export default MetierScanSection;
